export default __webpack_public_path__ + "static/media/bay.d2a8804f.svg";